import React, { useState, useEffect, useRef } from "react";
import { Form, Row, Col, Button, InputGroup } from "react-bootstrap";
import { toast } from "react-toastify";
import "./Filters.css";
import {
  IconX,
  IconRefresh,
  IconCalendarWeek,
  IconArrowRight,
  IconCalendarTime,
} from "@tabler/icons-react";
import DatePicker from "react-datepicker";

const initState = {
  status: "",
  createdFrom: null,
  createdTo: null,
};

const SectionHeader = ({ icon: Icon, type = "general", label }) => {
  const typeStyles = {
    general: { bg: "bg-orange-lt", text: "text-indigo" },
    dates: { bg: "bg-green-lt", text: "text-indigo" },
  };
  const styles = typeStyles[type] || typeStyles.general;

  return (
    <div className="filters-section-wrap">
      <div className="filters-section-label">
        <div
          className={`bagde_filters ${styles.bg} d-flex align-items-center justify-content-center section-icon`}
        >
          <Icon size={12} className={styles.text} />
        </div>
        <span className={styles.text}>{label}</span>
        <div className="filters-section-divider" />
      </div>
    </div>
  );
};

function Filters({
  show,
  onHide,
  initialValues = {},
  onApply,
  anchorRef,
  matchCount = 0,
  totalCount = 0,
}) {
  const [f, setF] = useState(initState);
  const panelRef = useRef(null);

  useEffect(() => {
    if (show) setF((p) => ({ ...initState, ...initialValues }));
  }, [show]);

  useEffect(() => {
    if (!show) return;
    const handleClickOutside = (e) => {
      if (
        panelRef.current &&
        !panelRef.current.contains(e.target) &&
        anchorRef?.current &&
        !anchorRef.current.contains(e.target)
      ) {
        if (e.target.closest(".react-datepicker")) return;
        onHide();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [show, onHide, anchorRef]);

  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const handleReset = () => {
    setF(initState);
  };

  const handleApply = () => {
    if ((f.createdFrom && !f.createdTo) || (!f.createdFrom && f.createdTo)) {
      toast.error('Please select both "from" and "to" for Created Date');
      return;
    }
    onApply?.(f);
    onHide();
  };

  const dateInput = (val, onChange, minDate, maxDate) => (
    <InputGroup>
      <InputGroup.Text>
        <IconCalendarWeek />
      </InputGroup.Text>
      <DatePicker
        className="form-control"
        selected={val}
        placeholderText="Select Date"
        onChange={onChange}
        minDate={minDate}
        maxDate={maxDate}
        showMonthDropdown
        showYearDropdown
      />
    </InputGroup>
  );

  if (!show) return null;

  return (
    <div ref={panelRef} className="filters-dropdown-panel">
      <div className="filters-header">
        <h5 className="filters-title">Refine Vendors</h5>
        <div className="d-flex align-items-center gap-3">
          <Button
            variant="link"
            className="filters-reset-btn text-secondary"
            onClick={handleReset}
          >
            <IconRefresh size={14} /> Reset all
          </Button>
          <span
            role="button"
            onClick={onHide}
            className="text-secondary"
            style={{ cursor: "pointer" }}
          >
            <IconX size={20} />
          </span>
        </div>
      </div>

      <div className="filters-body">
        <Row className="g-3 mb-2">
          <Col xs={12}>
            <div className="filters-field-label">Status</div>
            <Form.Select
              className="filters-input"
              value={f.status}
              onChange={(e) => set("status", e.target.value)}
            >
              <option value="">All</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </Form.Select>
          </Col>
        </Row>

        <SectionHeader icon={IconCalendarTime} type="dates" label="DATES" />

        <Row className="g-2 mb-3 align-items-end">
          <Col xs={5}>
            <div className="filters-date-field-label">Created Date from</div>
            {dateInput(f.createdFrom, (d) => set("createdFrom", d), undefined, new Date())}
          </Col>
          <Col xs={1} className="filters-arrow-col">
            <IconArrowRight size={16} className="text-secondary" />
          </Col>
          <Col xs={6}>
            <div className="filters-date-field-label">Created Date to</div>
            {dateInput(f.createdTo, (d) => set("createdTo", d), f.createdFrom || undefined, new Date())}
          </Col>
        </Row>
      </div>

      <div className="filters-footer">
        <div className="small text-muted">
          Live preview: <span className="fw-bold text-orange">{matchCount}</span> of{" "}
          <span className="fw-bold text-dark">{totalCount}</span> vendors
        </div>
        <div className="d-flex gap-2">
          <Button variant="light" onClick={onHide} className="border">
            Cancel
          </Button>
          <Button onClick={handleApply} className="text-white border-0 btn btn-warning">
            Apply Filters
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Filters;
